
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.1927 3C9.50644 2.90379 7.24193 4.84965 7 7.45078C6.92862 8.21769 7.50611 8.89564 8.28938 8.96553C9.05966 9.02543 9.76414 8.4709 9.83644 7.70308C9.94026 6.58313 10.9135 5.72637 12.0768 5.78627C13.1808 5.82983 14.1282 6.78098 14.1458 7.86282C14.1588 8.62065 13.7722 9.30859 13.1113 9.70521C11.516 10.66 10.5632 11.8436 10.5632 13.6025C10.5632 14.3722 11.2009 14.9966 11.9869 14.9966C12.773 14.9966 13.4107 14.3722 13.4107 13.6025C13.4107 12.8229 13.8538 12.5278 14.5972 12.0831C16.1044 11.18 17.023 9.54456 16.9933 7.81653C16.9507 5.26442 14.7974 3.10438 12.1927 3Z","fill":"#10001F"}}),_c('path',{attrs:{"d":"M12 20C12.8284 20 13.5 19.3284 13.5 18.5C13.5 17.6716 12.8284 17 12 17C11.1716 17 10.5 17.6716 10.5 18.5C10.5 19.3284 11.1716 20 12 20Z","fill":"#10001F"}})])
          )
        }
      }
    